import React from 'react'
import PropTypes from 'prop-types'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'

import * as Styled from './AttributeSelector.styles'

const AttributeSelector = props => {
  const { heading, image, optionCount, onDrawerOpen, type } = props
  const hasRequiredInformation = heading && image.src
  if (!hasRequiredInformation) return null

  const optionCountLabel = `Choose from ${optionCount} ${optionCount === 1 ? 'option' : 'options'}`

  return (
    <Styled.AttributeSelectorWrapper
      onClick={() => onDrawerOpen()}
      data-test={`${type?.replace(/\s+/g, '-').toLowerCase()}-attribute`}
    >
      <Styled.ImageWrapper>
        <Styled.Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          cropParams={image.cropParams}
          data-test='attribute-selector-image'
        />
      </Styled.ImageWrapper>
      <Styled.TextWrapper>
        <Styled.AttributeSelectorHeading data-test='attribute-selector-heading'>
          {heading}
        </Styled.AttributeSelectorHeading>
        {optionCount && <span data-test='attribute-selector-label'>{optionCountLabel}</span>}
      </Styled.TextWrapper>
      <Styled.IconWrapper>
        <ChevronIcon dir='right' height={24} width={24} fill='#262626' />
      </Styled.IconWrapper>
    </Styled.AttributeSelectorWrapper>
  )
}
AttributeSelector.propTypes = {
  onDrawerOpen: PropTypes.func.isRequired,
  heading: PropTypes.string,
  image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string }),
  optionCount: PropTypes.number
}

export default AttributeSelector
